/* eslint-disable */
export default {
  today: '今天',
  yesterday: '昨天',
  empty: '没有通话记录',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
